import { baseApi } from './baseApi'
import { IStatistics } from '../../types/statistics'

export const statisticsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getStatistics: builder.query<IStatistics, void>({
      query: () => '/statistics',
      providesTags: ['Statistics'],
    }),
  }),
})

export const { useGetStatisticsQuery } = statisticsApi
